import { Tradable, TradableAdapter } from "@modules/+new/core/tradables/domain/entities/tradable";
import { LeveragedToken as OldLeverageToken } from "@models/asset/cryptocoins/currencies/leveraged_tokens";
import { TRADABLES_TYPE } from "@helpers/constants";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface LeveragedToken extends Tradable {}

export class LeveragedTokenAdapter extends TradableAdapter {
	public adapt(coin: OldLeverageToken): LeveragedToken {
		const tradable = super.adapt(coin);
		return {
			...tradable,
			type: TRADABLES_TYPE.LEVERAGED_TOKEN
		};
	}
}
